<template>
	<div>
		<div style="color: #3e3e3e;font-size: 18px;margin-bottom: 15px;">营销管理>裂变海报>新建裂变海报</div>
		<div class="newADcontent">
			<div class="adExamples">
				<img src="../../../assets/haibao.png" />
			</div>
			<div class="adContent">
				<div class="title">
					<div class="blue"></div>
					<div style="flex: 1;">商品信息</div>
				</div>
				<p style="font-size: 14px;color: #909090;">*商品只能选择积分商品或会员产品的卷</p>
				<el-form style="margin-top: 10px;" ref="form" :model="addDataList" label-width="150px"
					label-position="left">
					<el-form-item label="关联商品/券">
						<el-button @click="addquan = true" type="text" style="color: #999;"><i
								class="el-icon-plus"></i>添加券</el-button>
						<p style="color: #999;font-size: 12px;">不能选择已经参与其他营销活动的商品/券，并且参与裂变海报的课程将不产生推广员佣金</p>
						<el-button @click="addGoods = true" type="text" style="color: #999;"><i
								class="el-icon-plus"></i>添加商品</el-button>
						<p style="color: #999;font-size: 12px;">不能选择剪发服务</p>
					</el-form-item>
					<div class="title">
						<div class="blue"></div>
						<div style="flex: 1;">活动设置</div>
					</div>
					<el-form-item label="活动名称">
						<el-input type="text" v-model="addDataList.name" size="small" style="width: 300px;"
							maxlength="10" show-word-limit placeholder="活动名称，不超过10个字"></el-input>
					</el-form-item>
					<el-form-item label="活动时间">
						<el-date-picker size="small" v-model="addDataList.time" type="datetimerange"
							format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始日期"
							end-placeholder="结束日期">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="海报背景">
						<el-upload style="display: inline-block;" class="avatar-uploader"
							action="https://jsonplaceholder.typicode.com/posts/">
							<el-button size="small">上传图片</el-button>
						</el-upload>
						<span style="margin-left: 20px;">左图为示例图</span>
						<p style="font-size: 12px;color: #C8C8C8;">点击上传图片，建议尺寸600*800px，jpg\png格式，图片小于1M</p>
						<el-checkbox>显示用户头像</el-checkbox>
					</el-form-item>
					<el-form-item label="海报获取">
						<el-radio v-model="addDataList.getPoster" label="1">下载海报</el-radio>
						<el-radio v-model="addDataList.getPoster" label="2">购买前/后均可获取</el-radio>
						<p style="color: #999;font-size: 12px;">选择“购买后才能获取”，用户购买产品后才能获得分享海报</p>
					</el-form-item>
					<el-form-item label="奖励比例">
						<el-input type="text" v-model="addDataList.percentage" size="small" style="width: 300px;"
							placeholder="请输入高于0且小于100的数"></el-input>%
						<p style="color: #999;font-size: 12px;">选择“购买后才能获取”，用户购买产品后才能获得分享海报</p>
					</el-form-item>
					<el-form-item>
						<el-button>取消</el-button>
						<el-button type="primary" style="margin-left: 20px;">保存</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
		<!-- 添加券 -->
		<el-dialog title="添加券/券包" :visible.sync="addquan" width="70%">
			<el-input v-model="serchQ" size="small" style="width: 200px;" placeholder="输入门店名称"></el-input>
			<el-button type="primary" style="margin-left: 20px;" size="small">筛选</el-button>
			<div style="margin-top: 20px;">
				<el-radio-group v-model="dataState" size="small">
					<el-radio-button label="券"></el-radio-button>
					<el-radio-button label="券包"></el-radio-button>
				</el-radio-group>
			</div>
			<div class="tabelContent" style="margin-top: 20px;">
				<el-checkbox-group v-model="dataCheck">
					<el-table :data="dataList" style="width: 100%">
						<el-table-column align="center" width="100" label="选择">
							<template slot-scope="scope">
								<el-checkbox :label="scope.row.name1"></el-checkbox>
							</template>
						</el-table-column>
						<el-table-column label="券名称" prop="name2" align="center"></el-table-column>
						<el-table-column prop="name3" align="center" label="试用范围"></el-table-column>
						<el-table-column prop="name4" align="center" label="券内容"></el-table-column>
						<el-table-column align="center" label="有效期">
							<template slot-scope="scope">
								至{{scope.row.name5 || 0}}
							</template>
						</el-table-column>
						<el-table-column align="center" label="已领取/优惠券总量">
							<template slot-scope="scope">
								{{scope.row.name6 || 0}}/{{scope.row.name7 || 0}}
							</template>
						</el-table-column>
						<el-table-column align="center" prop="name8" label="已使用">
						</el-table-column>
					</el-table>
				</el-checkbox-group>
				<el-pagination background style="margin-top: 30px;" layout="total, sizes, prev, pager, next, jumper"
					:page-size="10" :total="80">
				</el-pagination>
			</div>
		</el-dialog>
		<!-- 添加商品 -->
		<el-dialog title="添加商品" :visible.sync="addGoods" width="70%">
			<el-input v-model="serchQ" size="small" style="width: 200px;" placeholder="输入门店名称"></el-input>
			<el-button type="primary" style="margin-left: 20px;" size="small">筛选</el-button>
			<div style="margin-top: 20px;">
				<el-radio-group v-model="dataState" size="small">
					<el-radio-button label="券"></el-radio-button>
					<el-radio-button label="券包"></el-radio-button>
				</el-radio-group>
			</div>
			<div class="tabelContent" style="margin-top: 20px;">
				<el-checkbox-group v-model="goodsCheck">
					<el-table :data="goodsList" style="width: 100%"
						:header-cell-style="{background:'#F2F2F4','text-align':'center'}">
						<el-table-column align="center" width="100" label="选择">
							<template slot-scope="scope">
								<el-checkbox :label="scope.row.name1"></el-checkbox>
							</template>
						</el-table-column>
						<el-table-column label="名称" prop="name2" align="center"></el-table-column>
						<el-table-column align="center" label="几个">
							<template slot-scope="scope">
								{{scope.row.name3 || 0}}元
							</template>
						</el-table-column>
						<el-table-column align="center" label="积分">
							<template slot-scope="scope">
								{{scope.row.name4 || 0}}
							</template>
						</el-table-column>
						<el-table-column align="center" label="库存">
							<template slot-scope="scope">
								{{scope.row.name5 || 0}}
							</template>
						</el-table-column>
					</el-table>
				</el-checkbox-group>
				<el-pagination background style="margin-top: 30px;" layout="total, sizes, prev, pager, next, jumper"
					:page-size="10" :total="80">
				</el-pagination>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				addDataList: {
					name: "",
					time: "",
					img: "",
					head: false,
					getPoster: "",
					percentage: ""
				},
				addquan: false,
				serchQ: "",
				dataState: "券",
				dataList: [{
					name1: "1",
					name2: "剪发5元优惠券",
					name3: "全部门店",
					name4: "满100-50",
					name5: "2020-08-17 20:00",
					name6: 80,
					name7: 200,
					name8: 15
				}],
				dataCheck: [],
				addGoods: false,
				goodsCheck: [],
				goodsList: [{
					name1: "1",
					name2: "剪发",
					name3: 38,
					name4: 80,
					name5: 200,
				}]
			}
		}
	}
</script>

<style lang="less" scoped>
	p {
		margin: 0;
		padding: 0;
	}

	.title {
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #3E3E3E;
		display: flex;
		font-weight: bold;
		margin-bottom: 10px;

		.blue {
			width: 5px;
			height: 15px;
			background: #409EFF;
			border-radius: 2px;
			margin-right: 8px;
			position: relative;
			top: 4px;
		}
	}

	.newADcontent {
		display: flex;

		// & > div{
		// 	display: inline-block;
		// }
		.adContent {
			flex: 2;
		}

		.adExamples {
			flex: 1;
			padding: 0 30px;

			img {
				width: 300px;
				height: auto;
			}
		}
	}
</style>